import React, { useMemo } from 'react'
import * as Assets from '../../assets'
import classes from './WhiteLabel.module.scss'


export const WhiteLabel = ():JSX.Element=> {

    const whitelabel = useMemo<JSX.Element | undefined>(() => {
        const brand = window.location.hostname.split(".")[0];

        switch (brand) {
            case "marken":
            case "marken-dev":
            case "marken-test":
            case "marken-local": {
                return (<img src={Assets.Customers.Marken_UPS_Logo} alt={""} />);
            }
            case "cryolab":
            case "cryolab-dev":
            case "cryolab-test":
            case "cryolab-local": {
                return (<img src={Assets.Customers.Cryolab_Logo} alt={""} />);
            }
            default: {
                return undefined;
            }
        }
    }, []);

    if (!whitelabel) {
        return <></>;
    }

    return (
        <div className={classes.whitelabel}>{whitelabel}</div>
    );
};